import React from 'react';
import { ChevronDown } from 'lucide-react';

const Select = ({ disabled = false, label, name, options = [], value, onChange, required, py = 3 }) => {
  return (
    <div className="flex flex-col gap-1 relative">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}
          {required && <span className="ml-1.5">*</span>}
        </label>
      )}
      <div className="relative">
        <select
          id={name}
          name={name}
          value={value}
          disabled={disabled}
          required={required}
          onChange={onChange}
          className={`appearance-none w-full border border-bluePale rounded-xl px-3 py-${py} text-base placeholder-blueSteel bg-white pr-10`}
        >
          <option value=""></option>

          {options.map((opt, i) => (
            <option key={i} value={opt.value || opt} className="text-blueDarker">
              {opt.label || opt}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
          <ChevronDown size={18} className="text-blueSteel" strokeWidth={1.5} />
        </div>
      </div>
    </div>
  );
};

export default Select;
